module.exports = __webpack_public_path__ + "mapPin-primary.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mapPin-primary.png
// module id = 1954
// module chunks = 4